import { z } from 'zod';

export const requiredNumber = (
  fieldName: string,
  min?: number,
  max?: number,
  messages?: { min?: string; max?: string },
) => {
  let schema = z.number({
    required_error: `${fieldName} is required`,
  });

  if (min !== undefined) {
    schema = schema.min(min, {
      message: messages?.min || `${fieldName} must be at least ${min}`,
    });
  }

  if (max !== undefined) {
    schema = schema.max(max, {
      message: messages?.max || `${fieldName} cannot exceed ${max}`,
    });
  }

  return schema;
};

export const requiredString = (fieldName: string, minLength: number) =>
  z.string({ required_error: `${fieldName} is required` }).min(minLength, {
    message: `${fieldName} must be at least ${minLength} characters`,
  });

export const requiredPhoneNumber = () => {
  return z
    .string()
    .trim()
    .min(7, { message: 'Phone number is too short (minimum 7 digits)' })
    .max(15, { message: 'Phone number is too long (maximum 15 digits)' })
    .regex(/^(?:\+?[1-9]\d{6,14}|0[1-9]\d{6,14})$/, {
      message: 'Invalid phone number format',
    });
};

export const requiredDate = (fieldName: string) =>
  z.preprocess(
    (date) => (typeof date === 'string' ? new Date(date) : date),
    z.date({
      required_error: `${fieldName} is required.`,
      invalid_type_error: `${fieldName} must be a valid date.`,
    }),
  );

export const requiredBoolean = (fieldName: string) =>
  z.boolean({
    required_error: `${fieldName} is required.`,
    invalid_type_error: `${fieldName} must be a boolean.`,
  });

export const requiredStringArray = (fieldName: string, minLength: number) =>
  z
    .array(z.string(), { required_error: `${fieldName} is required.` })
    .min(minLength, { message: `At least ${minLength} ${fieldName} required.` });

export const optionalString = () => z.string().optional();
